import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { securityFeatures } from '@/mocks/smart-restaurant';

export default function Security() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="安全与可信"
          title="让每一次操作，都可授权、可审计、可追溯"
          subtitle="味聚按最小权限和职责分离设计组织与岗位，关键操作经过授权、审批和审计，为规模化经营提供可信底座。"
        />

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {securityFeatures.map((feature, idx) => (
            <Reveal key={feature.id} delay={idx * 40}>
              <div className="flex items-start gap-3 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-300 transition-colors duration-300">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 flex-shrink-0">
                  <i className={`${feature.icon} text-base`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{feature.title}</div>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{feature.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-8 text-xs text-foreground-500 leading-relaxed max-w-3xl mx-auto text-center">
          涉及资质、合作方与合规认证的具体内容，待交付范围与法务审核确认后再行展示。
        </p>
      </div>
    </section>
  );
}